import './AvailableBotForJoinTableByLink.styles.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import React, { FC, useRef, useState } from 'react';

import availableBotStore from '../../../store/AvailableBotStore';
import notificationStore from '../../../store/NotificationStore';
import userSettingsStore from '../../../store/UserSettingsStore';
import { getBuyInConfirmDialog } from '../../AvailableBotForManageParams/availableBot.render.utils';
import { AvailableBotForJoinTableByLinkProps } from './AvailableBotForJoinTableByLink.types';

const AvailableBotForJoinTableByLink: FC<
  AvailableBotForJoinTableByLinkProps
> = ({ bot, isVisible, onHide, doOnSuccess }) => {
  const [joinLink, setJoinLink] = useState<string>('');
  const [nick, setNick] = useState<string>('');
  const buyInRef = useRef<number | null>(null);

  const join = (buyIn: number | null): void => {
    void availableBotStore
      .joinTableByLink(bot.pid, bot.room, nick, joinLink, buyIn)
      .then(() =>
        notificationStore.showNotification({
          severity: 'success',
          summary: 'Success',
          detail: (
            <>
              Request sent to the bot (<b>{bot.pid}</b>) to join table by the
              link with nick {nick}
            </>
          ),
        }),
      )
      .catch(() =>
        notificationStore.showNotification({
          severity: 'error',
          summary: 'Error',
          detail: 'Error while sending request to the bot',
        }),
      )
      .finally(() => {
        if (doOnSuccess) {
          doOnSuccess();
        }
        setJoinLink('');
        setNick('');
        onHide();
      });
  };

  const onJoinTable = (): void => {
    if (userSettingsStore.settings.table.askBuyInBeforeSit) {
      getBuyInConfirmDialog(buyInRef, () => join(buyInRef.current));
    } else {
      join(null);
    }
  };

  return (
    <Dialog
      className="AvailableBotForJoinTableByLink-Component"
      header="JOIN TABLE BY LINK"
      headerClassName="text-center"
      visible={isVisible}
      onHide={onHide}
      onClick={e => e.stopPropagation()}
    >
      <label htmlFor="join-nick-input" className="block mb-2">
        Enter nick:
      </label>
      <InputText
        id="join-nick-input"
        className="join-nick-input"
        value={nick}
        maxLength={400}
        onChange={e => setNick(e.target.value)}
      />
      <label htmlFor="join-link-input" className="block mb-2 mt-4">
        Enter link to join the table:
      </label>
      <InputText
        id="join-link-input"
        className="join-link-input"
        value={joinLink}
        maxLength={400}
        onChange={e => setJoinLink(e.target.value)}
      />
      <div className="join-link-btn">
        <Button className="p-button" disabled={!joinLink} onClick={onJoinTable}>
          Join
        </Button>
      </div>
    </Dialog>
  );
};

export default AvailableBotForJoinTableByLink;
